// Example of SVG converted to js array, so it can be used with CIcon.
// the first argument is two last values of svg viewBox,
// the second argument is the SVG content stripped of SVG tags
export const carManager = ['16 16', `
  <g>
    <g style="fill:white;">
      <path d="M1.50002 1.2H15.6667C15.7384 1.2 15.8 1.2616 15.8 1.33333V6.33333C15.8 6.40507 15.7384 6.46667 15.6667 6.46667H1.50002C1.42829 6.46667 1.36669 6.40507 1.36669 6.33333V1.33333C1.36669 1.2616 1.42829 1.2 1.50002 1.2ZM1.50002 9.53333H15.6667C15.7384 9.53333 15.8 9.59493 15.8 9.66667V14.6667C15.8 14.7384 15.7384 14.8 15.6667 14.8H1.50002C1.42829 14.8 1.36669 14.7384 1.36669 14.6667V9.66667C1.36669 9.59493 1.42829 9.53333 1.50002 9.53333Z" stroke="var(--active-svg-stroke-color, #C2CFE0)" stroke-width="1.4"/>
    </g>
  </g>
`]
